// Centralized API base URL selection for local and production
// Priority: REACT_APP_API_BASE_URL (if set) > localhost default > production URL
const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:3001'
    : 'https://kokun02-production.up.railway.app');

export default API_BASE;

